import Vue from 'vue';
import {numberDecimals} from '@/utils';

Vue.filter('numberDecimals', value => {
    return value ? numberDecimals(value) : 0;
});
